import { createContext, useContext, useState, useRef, useCallback } from "react";

// Lets the editor register a save handler that the Header's nav/logout prompts can call.
const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const saveCallbackRef = useRef(null);

  // Keep these stable so effects elsewhere don't re-register listeners on every render.
  const setSaveCallback = useCallback((fn) => {
    saveCallbackRef.current = fn;
  }, []);

  const invokeSaveCallback = useCallback(async () => {
    if (saveCallbackRef.current) {
      await saveCallbackRef.current();
    }
  }, []);

  return (
    <UnsavedChangesContext.Provider
      value={{
        hasUnsavedChanges,
        setHasUnsavedChanges,
        setSaveCallback,
        invokeSaveCallback,
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error(
      "useUnsavedChanges must be used within UnsavedChangesProvider",
    );
  }
  return context;
};
